import { React } from 'Imports';
import { Card, CardContent, Grid, Typography } from 'MaterialUIComponents';
import { StatisticsDashboardFilterModel, EventStatus, VideoEventWorkflowStatusIdEnum } from '../../../generated/api';
import { IIntegrationPartnerDataInjectedProps, IntegrationPartnerDataService } from '../../../state/IntegrationPartnerDataFreezerService';
import { IConfigServiceInjectedProps, ConfigService } from '../../../state/ConfigFreezerService';
import {
    IVideoEventFilterServiceMultiselectInjectedProps,
    VideoEventFilterServiceMultiselect,
} from '../../../state/VideoEventFilterFreezerServiceMultiselect';
import { useEffect, useState } from 'react';
import { DashboardTooltip } from '$Components/Dashboards/DashboardTooltip';
import { useNavigate } from 'react-router-dom';
import { StandardProtectedRoutePaths } from '../../../router/route-sets/standard-route-config';

interface IEventStatusWidgetProps {
    eventStatusRequested: EventStatus | undefined;
    dateRange: StatisticsDashboardFilterModel;
}

type EventStatusWidgetProps = IEventStatusWidgetProps &
    IVideoEventFilterServiceMultiselectInjectedProps &
    IConfigServiceInjectedProps &
    IIntegrationPartnerDataInjectedProps;

const styles = require('../styles/EventStatusWidget.scss') as {
    title: string;
    status: string;
    card: string;
    cardContent: string;
    statusLabel: string;
    statusCount: string;
    lastUpdated: string;
};
const _EventStatusWidget = (props: EventStatusWidgetProps) => {
    const [eventStatusData, setEventStatusData] = useState<EventStatus>();
    const { eventStatusRequested, dateRange, videoEventFilterMultiselect, integrationPartnerData } = props;
    const navigate = useNavigate();

    useEffect(() => {
        setEventStatusData(eventStatusRequested);
    }, [eventStatusRequested]);

    const navigateToStatus = (statusKey?: VideoEventWorkflowStatusIdEnum): void => {
        // can't filter to "all time" - use 30 days
        const end = dateRange.endDate;
        const start = dateRange.startDate;

        statusKey != undefined
            ? videoEventFilterMultiselect.updateFilterOptions([], [], [], start, end, false, false, [statusKey], '', [], [], true, true)
            : videoEventFilterMultiselect.updateFilterOptions([], [], [], start, end, false, false);
        const path = integrationPartnerData.getIntegrationPartnerManager().getLinkUrl(StandardProtectedRoutePaths.VideoEvents);
        navigate(path, { replace: false });
    };

    return (
        <>
            <Grid container>
                <DashboardTooltip
                    prompt="What do the statuses mean?"
                    description={
                        <div>
                            <strong>New:</strong> A video event that has not been watched or shared.
                            <br />
                            <strong>In Progress:</strong> A video event that has been watched by at least one user.
                            <br />
                            <strong>Sent to Driver:</strong> A video event that has been shared and not accepted or disputed yet.
                            <br />
                            <strong>Driver Accepted:</strong> A video event that has been shared and accepted by recipient.
                            <br />
                            <strong>Driver Disputed:</strong> A video event that has been shared and disputed by recipient.
                            <br />
                            <strong>No Response:</strong> A video event that has been shared and recipient has not responded in 12+ hours.
                            <br />
                            <strong>Completed:</strong> A video event that was marked complete after an action was taken.
                            <br />
                            <strong>Dismissed:</strong> A video event that was marked dismissed after determining no action was needed.
                        </div>
                    }
                />
                <Grid item xs={6}>
                    <Typography className={styles.title}>Event Status Queue</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent={'flex-start'}>
                {eventStatusData?.data?.map((x, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={idx} className={styles.status}>
                        <Card className={styles.card} onClick={() => navigateToStatus(x.statusKey)}>
                            <CardContent className={styles.cardContent}>
                                <Typography className={styles.statusLabel}>{x.label}</Typography>
                                <Typography className={styles.statusCount}>{x.count}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};
export const EventStatusWidget = ConfigService.inject(
    VideoEventFilterServiceMultiselect.inject(IntegrationPartnerDataService.inject(_EventStatusWidget)),
);
